module.exports = __webpack_public_path__ + "img/wein-wellness-desktop.8800f082.jpg";